import { __assign, __read, __spreadArray } from "tslib";
import React from "react";
import { Box, Checkbox, Divider, Typography } from "@material-ui/core";
var MultipleCheckboxFilter = function (_a) {
    var multipleCheckbox = _a.multipleCheckbox, setMultipleCheckbox = _a.setMultipleCheckbox;
    var allFilters = multipleCheckbox.allFilters, checkboxFilters = multipleCheckbox.checkboxFilters;
    return (React.createElement(Box, null,
        React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center" },
            React.createElement(Box, null,
                React.createElement(Checkbox, { color: "primary", checked: allFilters.checked, onChange: function (event) {
                        return setMultipleCheckbox(function (prevState) { return (__assign(__assign({}, prevState), { allFilters: __assign(__assign({}, prevState.allFilters), { checked: event.target.checked }) })); });
                    } })),
            React.createElement(Box, { width: 200 },
                React.createElement(Typography, null, allFilters.label))),
        React.createElement(Divider, null),
        React.createElement(Box, { display: "flex", style: { flexFlow: "row wrap" } }, checkboxFilters.map(function (_a) {
            var checked = _a.checked, label = _a.label, id = _a.id;
            return (React.createElement(Box, { mt: 2, key: id, display: "flex", justifyContent: "center", alignItems: "center" },
                React.createElement(Box, null,
                    React.createElement(Checkbox, { color: "primary", checked: checked, onChange: function (event) {
                            return setMultipleCheckbox(function (prevState) {
                                var checkboxList = __spreadArray([], __read(prevState.checkboxFilters), false);
                                var checkboxIndex = checkboxList.findIndex(function (checkbox) { return checkbox.id === id; });
                                if (checkboxIndex === -1) {
                                    return prevState;
                                }
                                checkboxList[checkboxIndex] = __assign(__assign({}, checkboxList[checkboxIndex]), { checked: event.target.checked });
                                return __assign(__assign({}, prevState), { checkboxFilters: checkboxList });
                            });
                        } })),
                React.createElement(Box, { width: 200 },
                    React.createElement(Typography, null, label))));
        }))));
};
export default MultipleCheckboxFilter;
//# sourceMappingURL=MultipleCheckboxFilter.js.map